import React, { useEffect, useState } from "react";
import { CheckCircle2, CircleAlert } from "lucide-react";
const placeholderImage =
  "https://www.kitshouse.org/wp-content/uploads/2019/09/no-image-1.jpg";

const ModalReceiverData = ({
  isClient = false,
  isOpenReceiverData,
  showSuccessScreenReceiverData,
  closeModalReceiverData,
  formDataReceiverData,
  handleChange,
  handlePhoneChange,
  handleBlur,
  handleSubmit,
  loadingReceiverData,
  selectedNegotiationReceiverData,
  errorsReceiverData,
  errorReceiverData,
}) => {
  const isReceiverLocked = Boolean(
    selectedNegotiationReceiverData?.receiver_data_locked,
  );

  const shouldLockFields = !isClient && isReceiverLocked;

  useEffect(() => {
    if (isOpenReceiverData) {
      document.documentElement.style.overflow = "hidden";
    } else {
      document.documentElement.style.overflow = "auto";
      document.body.style.overflow = "unset";
    }

    return () => {
      document.documentElement.style.overflow = "auto";
      document.body.style.overflow = "unset";
    };
  }, [isOpenReceiverData]);

  if (!isOpenReceiverData) return null;

  return (
    <div
      className="modal-overlay"
      onClick={closeModalReceiverData}
      style={{
        alignItems: "flex-start",
        overflowY: "auto",
        padding: "20px 12px",
      }}
    >
      {isClient ? (
        <div
          className="modal-content"
          onClick={(e) => e.stopPropagation()}
          style={{
            height: "auto",
            maxHeight: "none",
            margin: "auto",
          }}
        >
          <div className="modal-header">
            <h2>Dados do Destinatário</h2>
          </div>

          <div className="modal-body">
            {showSuccessScreenReceiverData ? (
              <div className="receiver-success-container">
                <CheckCircle2 size={90} className="receiver-success-icon" />

                <h3 style={{ marginBottom: -5 }}>
                  Destinatário adicionado com sucesso
                </h3>

                <p>
                  O destinatário será notificado por e-mail com os dados
                  enviados.
                </p>

                <button
                  onClick={closeModalReceiverData}
                  className="action-btn ghost"
                >
                  Entendi
                </button>
              </div>
            ) : (
              <>
                {selectedNegotiationReceiverData?.trip && (
                  <p style={{ marginBottom: 12 }}>
                    <strong>Viagem:</strong>{" "}
                    {selectedNegotiationReceiverData.trip?.cidade_origem ||
                      selectedNegotiationReceiverData.trip?.de}{" "}
                    →{" "}
                    {selectedNegotiationReceiverData.trip?.cidade_destino ||
                      selectedNegotiationReceiverData.trip?.para}
                  </p>
                )}
                <form onSubmit={handleSubmit}>
                  <div
                    style={{
                      backgroundColor: "#fde8e8",
                      color: "#c81e1e",
                      padding: "12px 16px",
                      borderRadius: "8px",
                      border: "1px solid #f8b4b4",
                      fontSize: "14px",
                      marginTop: "12px",
                      marginBottom: "20px",
                      display: "flex",
                      display: errorReceiverData ? "block" : "none",
                      alignItems: "center",
                      justifyContent: "center",
                      textAlign: "center",
                      fontWeight: "500",
                      boxShadow: "0 2px 4px rgba(0,0,0,0.05)",
                      width: "95%",
                      marginLeft: "auto",
                      marginRight: "auto",
                    }}
                  >
                    {errorReceiverData}
                  </div>
                  <div className="form-group">
                    <label>Nome</label>

                    <input
                      type="text"
                      name="name"
                      value={
                        formDataReceiverData.name ||
                        formDataReceiverData.temporary_receiver?.name ||
                        ""
                      }
                      onChange={handleChange}
                      onBlur={handleBlur}
                      disabled={shouldLockFields || loadingReceiverData}
                      className={
                        errorsReceiverData.name ? "input-error-field" : ""
                      }
                    />

                    {errorsReceiverData.name && (
                      <span className="input-error">
                        {errorsReceiverData.name}
                      </span>
                    )}
                  </div>

                  <div className="form-group">
                    <label>Email</label>

                    <input
                      type="email"
                      name="email"
                      value={
                        formDataReceiverData.email ||
                        formDataReceiverData.temporary_receiver?.email ||
                        ""
                      }
                      onChange={handleChange}
                      onBlur={handleBlur}
                      disabled={shouldLockFields || loadingReceiverData}
                      className={
                        errorsReceiverData.email ? "input-error-field" : ""
                      }
                    />

                    {errorsReceiverData.email && (
                      <span className="input-error">
                        {errorsReceiverData.email}
                      </span>
                    )}
                  </div>

                  <div className="form-group">
                    <label>Telefone</label>

                    <div
                      className={
                        errorsReceiverData.phone
                          ? "phone-wrapper input-error-field"
                          : "phone-wrapper"
                      }
                    >
                      <div className="ddi-box">
                        <img
                          src="https://flagcdn.com/w40/br.png"
                          alt="Brasil"
                          className="flag"
                        />

                        <span>+55</span>
                      </div>

                      <input
                        type="text"
                        name="phone"
                        value={
                          formDataReceiverData.phone ||
                          formDataReceiverData.temporary_receiver?.phone ||
                          ""
                        }
                        onChange={(e) => handlePhoneChange(e.target.value)}
                        onBlur={handleBlur}
                        disabled={shouldLockFields || loadingReceiverData}
                        style={{
                          background: errorsReceiverData.phone
                            ? "#fff1f1"
                            : "transparent",
                        }}
                      />
                    </div>

                    {errorsReceiverData.phone && (
                      <span className="input-error">
                        {errorsReceiverData.phone}
                      </span>
                    )}
                  </div>

                  {formDataReceiverData.is_receiver_readded && (
                    <div className="modal-info-block">
                      Adicione novamente os dados do destinatário
                    </div>
                  )}

                  <div className="modal-actions">
                    <button
                      type="button"
                      className="action-btn ghost"
                      onClick={closeModalReceiverData}
                      disabled={loadingReceiverData}
                    >
                      Cancelar
                    </button>

                    {(!isReceiverLocked || isClient) && (
                      <button
                        type="submit"
                        className="action-btn save-modal"
                        disabled={loadingReceiverData}
                      >
                        {loadingReceiverData
                          ? "Enviando..."
                          : isReceiverLocked
                            ? "Alterar destinatário"
                            : "Adicionar destinatário"}
                      </button>
                    )}
                  </div>
                </form>
              </>
            )}
          </div>
        </div>
      ) : (
        <div className="profile-receiver-card">
          {formDataReceiverData.is_confirmed ? (
            <>
              <div className="avatar-receiver-wrapper">
                <div className="avatar-receiver-container">
                  <img
                    src={formDataReceiverData.img || placeholderImage}
                    alt="Foto do destinatário"
                    className="avatar-receiver-profile-preview"
                  />
                </div>
              </div>

              <h2 className="profile-receiver-name">
                {formDataReceiverData.name || ""}
              </h2>

              <p className="profile-receiver-role">Destinatário verificado</p>

              <div className="profile-receiver-info">
                <div className="info-receiver-card">
                  <div className="info-receiver-icon">@</div>

                  <div className="info-receiver-content">
                    <div className="info-receiver-label">Email</div>

                    <div className="info-receiver-value">
                      {formDataReceiverData.email || ""}
                    </div>
                  </div>
                </div>

                <div className="info-receiver-card">
                  <div className="info-receiver-icon">☎</div>

                  <div className="info-receiver-content">
                    <div className="info-receiver-label">Telefone</div>

                    <div className="info-receiver-value">
                      {formDataReceiverData.phone || ""}
                    </div>
                  </div>
                </div>
              </div>

              <div className="modal-actions">
                <button
                  type="button"
                  className="action-btn ghost"
                  onClick={closeModalReceiverData}
                  disabled={loadingReceiverData}
                >
                  Cancelar
                </button>
              </div>
            </>
          ) : (
            <div className="receiver-success-container">
              <CircleAlert size={90} className="receiver-failure-icon" />

              <h3 style={{ marginBottom: -5 }}>Destinatário indisponível</h3>

              <p>Aguardando a confirmação do destinatário para esta viagem</p>

              <button
                onClick={closeModalReceiverData}
                className="action-btn ghost"
              >
                Entendi
              </button>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default ModalReceiverData;
